export async function registerServiceWorker(scriptPath = '/static/service-worker.js') {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service workers are not supported in this browser.');
    return;
  }
  console.log('✅ Service Worker in navigator.');

  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register(scriptPath);
      console.log('✅ Service Worker registered:', reg);
    } catch (err) {
      console.error('❌ Service Worker registration failed:', err);
    }
  });
}
    